import { Utils } from "helpers/utils";
import { APIClient } from "./apiCore";

class ThirdApi {
  private api = new APIClient();

  private static API_URL: any = null;
  static setApiUrl(value: any) {
    this.API_URL = value;
  }

  private getUrl = (type: string) => {
    //'this.API_URL:', ThirdApi.API_URL);
    if (!ThirdApi.API_URL) return null;
    const url = ThirdApi.API_URL.filter((obj: any) => obj.type.toLowerCase() == type.toLowerCase()).map((obj: any) => obj.url);
    if (!url || url.length <= 0) {
      console.error('cannot find URL of type ' + type + ' from data:', ThirdApi.API_URL);
    }
    return Array.isArray(url) ? url[0] : url;
    // return url[0];
  }

  DConnect_UpdateNewsUnread = async (customerIsCdSys: any, newsId: any): Promise<any> => {
    if (!Utils.IsViewAs()) {
      try {
        const url = this.getUrl('UPDATE_NEWS_READ');
        console.log('DConnect_UpdateNewsUnread (' + url + '): ', { customerIsCdSys, newsId });
        await this.api.fnPostForm(url, { NewsID: newsId });
      } catch (e) {
        console.error('DConnect_UpdateNewsUnread Err:' + (e as Error).message);
      }
    }
  }


  DConnect_RegisterWebUserId = async (customerIsCdSys: any, webUserId: any, logMsg?: string[]): Promise<any> => {
    if (customerIsCdSys === undefined || webUserId === undefined) {
      console.log('DConnect_RegisterWebUserId with undefine parameter, then ignore');
      return;
    }
    if (customerIsCdSys != 1 /*dconnect*/ && customerIsCdSys != 2 /*2s online*/) {
      console.log('Customer ap is ' + customerIsCdSys + ', then ignore');
      return;
    }
    if (!Utils.IsViewAs()) {
      try {
        const url = this.getUrl(customerIsCdSys == 1 /*dconnect*/ ? "UPDATE_WEB_USERID_COOKIE" : "UPDATE_WEB_USERID_COOKIE_2");
        // console.log('DConnect_RegisterWebUserId (' + url + '): ', { customerIsCdSys, webUserId });
        //console.log('url:', url);
        if (!url) {
          console.error('URL not give, please check api URL in database');
          if (logMsg) logMsg.push('No URL to register provided');
        } else {
          const dCookieApi = url;
          const cookieValueSet = webUserId;
          //console.log('call api ' + dCookieApi + ' with value ' + webUserId);
          // Call the WebMethod using fetch
          fetch(dCookieApi, {
            method: "POST",
            credentials: "include", // Ensures cookies are included in the response
            headers: {
              "Content-Type": "application/json",
              'Authorization': `Bearer ${Utils.JwtTokenGet()}` // 20250708
            },
            body: JSON.stringify(cookieValueSet) // Replace "exampleValue" with the actual value
          })
            .then(response => response.json())
            .then(data => {
              //console.log('set webuser id:' + data.message)
              if (logMsg) logMsg.push('Register success');
              if (logMsg) alert(logMsg.join("\n"));
            }
            )
            .catch(error => {
              logMsg?.push('Register Failed: ' + Utils.GetMessageFromExecption(error));
              console.error("Error2:", error);
              if (logMsg) alert(logMsg.join("\n"));
            });
        }
      } catch (e) {
        logMsg?.push('Register Failed: ' + Utils.GetMessageFromExecption(e));
        console.error('DConnect_RegisterWebUserId Err:' + (e as Error).message);
        if (logMsg) alert(logMsg.join("\n"));
      }
    } else {
      if (logMsg) logMsg.push('Not allow in view as mode');
      if (logMsg) alert(logMsg.join("\n"));
    }



  }



}
export { ThirdApi };
